import React from "react";
import "./lims.css";
import Carousellims from "../navbar/carousellims";
import Footer from "../navbar/footer";
import Navbarrr from "../navbar/navbarrr";
import { Card } from "antd";

function Lims() {
  return (
    <div>
      <Navbarrr />
      <Carousellims />
      <div className="bccckggrrrrr">
        <h3 className="txrtrrrtrtf">A Warm Welcome</h3>
        <h5 style={{ color: "white" }}>
          <br />
          Welcome to <span style={{ color: "#FDA20B" }}>LIMS</span>, a Pre
          Kindergarten to Matric
          <br /> and boarding school for boys and girls located in Lahore
          <br />
          <br />
          Our Head Master{" "}
          <span style={{ color: "#FDA20B" }}>Sir Shahroz Khan</span> said,
          <br />
          <br />
          ‘With education, Human can do or be anything’.
          <br /> <br />
          We always have, and always will, champion equality for boys and girls.
        </h5>
        <p className="txrtrrrtrtf">Our key points of difference</p>
        <h5 style={{ color: "white" }}>
          <span style={{ color: "#FDA20B" }}>LIMS</span> education, helps our
          Students thrive today and tomorrow.
          <br /> We empower amazing students to do amazing things. <br /> <br />
          We invite you to explore …
        </h5>
        <div className="cardmiddlims">
          <Card
            bordered={false}
            style={{ width: 300, background: "transparent" }}
          >
            <p className="ldrrrrrr">Academic Excellence</p>
            <p className="ldrrrrrlims">
              HIGH EXPECTATIONS DELIVER OUTSTANDING RESULTS
            </p>
          </Card>
          <Card
            bordered={false}
            style={{ width: 300, background: "transparent" }}
          >
            <p className="ldrrrrrr">Technology</p>
            <p className="ldrrrrrlims">
              we recognise the importance of up-to-date and innovative
              technology
            </p>
          </Card>

          <Card
            bordered={false}
            style={{ width: 300, background: "transparent" }}
          >
            <p className="ldrrrrrr">Spiritual Growth</p>
            <p className="ldrrrrrlims">
              INCLUSIVE COMMUNITY FOSTERS VALUES AND GUIDES FAITH FORMATION
            </p>
          </Card>
        </div>
        <div className="cardmidd1lims">
          <Card
            bordered={false}
            style={{ width: 300, background: "transparent" }}
          >
            <p className="ldrrrrrr">Leaders of Character</p>
            <p className="ldrrrrrlims">
              MISSION CHALLENGES ALL TO BE PEACEMAKERS, CHANGEMAKERS.
            </p>
          </Card>
        </div>
        <div>
          {" "}
          <p className="txrtrrrtrtf">News and events</p>
          <h5 style={{ color: "white" }}>
            <span style={{ color: "#FDA20B" }}>LIMS</span> is a vibrant and busy
            place. <br />
            <br />
            Our news and events section keeps you up to date with what's going
            on.
            <br />
            <br />
            Share in our joys. Take part in our events.
            <br />
            <br />
            Visit often – we don't want you to miss a thing.
          </h5>
          <h4 style={{ color: "white", marginTop: "3rem" }}>
            If you're looking for{" "}
            <span style={{ color: "#FDA20B" }}>
              a place your child will love
            </span>{" "}
            then <span style={{ color: "#FDA20B" }}>LIMS</span> is for you.{" "}
            <br />
            Our commitment is to be the best preschool possible. Contact us
            today to see if we are a fit for you and your child.
          </h4>
        </div>
        <div className="divdghscdfsbvhkg"></div>
      </div>

      <Footer />
    </div>
  );
}

export default Lims;
